<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/za06bN/tc-custom/9781646566570.jpg?1723406086135" alt="This image is the cover for the book Penance"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Penance
      </h1>
      <p class="bookDescription body article font2">
        <i>Bound by misery. Marked by sin. Set free by death.</i><br/><br/>Barely into their teens, without homes, they dwell in neon shadows, the violent eddies of urban America. They trade their innocence for money, abuse their hopes, and then a monster comes ...<br/><br/>A monster without fangs or claws, but more deadly. Because of them, he has lost everything: his wife, his family. And he vows to clean the streets of Chicago ... for good.<br/><br/>One of the street kids and a man of the cloth form a desperate pact. Together, they will find the madman whose basement has become a chamber of horrors ...
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rick R. Reed
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4d721cea